import { Flex, Text, Card, Box, Image, Icon } from '@podiumhq/design-system';
import { motion } from 'framer-motion';
import profilepic1 from './assets/profile1.png';
import profilepic2 from './assets/profile2.png';
import profilepic3 from './assets/profile3.svg';
import profilepic4 from './assets/profile4.png';
import avatarimg from './assets/avatar.svg';
import phoneIcon from './assets/phoneIcon.svg';
import playIcon from './assets/playIcon.svg';
import volumeIcon from './assets/volumeIcon.svg';
import moneyIcon from './assets/moneyIcon.svg';
import footerPic from './assets/footer.png';

const Imagery = () => {
  const cardTransition = {
    duration: 5,
    delay: 2,
    ease: 'backInOut',
    type: 'spting',
    stiffness: 150,
  };

  return (
    <Flex
      bg="black.base"
      width="50%"
      color="silver.lightest"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Text
          textAlign="center"
          fontSize="26px"
          fontWeight="700"
          w="346px"
          mb="64px"
        >
          Join 100,000+ businesses using Podium to grow
        </Text>
      </motion.div>
      <Box display="contents">
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <CenterCard />
        </motion.div>
        <motion.div
          initial={{ x: -120, y: -150 }}
          animate={{
            opacity: [0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 1],
            scale: [0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 1],
            y: [
              -100, -100, -100, -100, -100, -150, -150, -100, -100, -100, -150,
            ],
          }}
          transition={cardTransition}
        >
          <LeftCard />
        </motion.div>
        <motion.div
          initial={{ x: 100, y: -380 }}
          animate={{
            opacity: [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1],
            scale: [0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1],
            y: [
              -320, -380, -380, -320, -320, -320, -320, -320, -320, -320, -380,
            ],
          }}
          transition={cardTransition}
        >
          <RightOneCard />
        </motion.div>
        <motion.div
          initial={{ x: 127, y: -370 }}
          animate={{
            opacity: [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1],
            scale: [0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1],
            y: [
              -320, -320, -320, -320, -320, -320, -320, -370, -370, -320, -370,
            ],
          }}
          transition={cardTransition}
        >
          <RightTwoCard />
        </motion.div>
        <motion.div
          initial={{ x: 115, y: -360 }}
          animate={{
            opacity: [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 1],
            scale: [0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 1],
            y: [
              -300, -300, -300, -360, -360, -300, -300, -300, -300, -300, -360,
            ],
          }}
          transition={cardTransition}
        >
          <RightThreeCard />
        </motion.div>
      </Box>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.8 }}
      >
        <FooterQuote />
      </motion.div>
    </Flex>
  );
};

export default Imagery;

const CenterCard = () => {
  return (
    <Card color="black.base" p="16px 16px 8px" fontSize="12px">
      <Flex flexDir="column">
        <CenterCardProfile img={profilepic1} />
        <CenterCardProfile img={profilepic2} />
        <CenterCardProfile img={avatarimg} />
        <CenterCardProfile img={profilepic3} />
      </Flex>
    </Card>
  );
};

const CenterCardProfile = ({ img }) => {
  return (
    <Flex pb="20px">
      <Box borderRadius="8px" w="34px" h="34px" overflow="hidden">
        <Image w="100%" src={img} />
      </Box>
      <Flex flexDir="column" justifyContent="space-between" pl="6px">
        <GreyLine w="100px" />
        <GreyLine w="200px" />
      </Flex>
    </Flex>
  );
};

const LeftCard = () => {
  return (
    <Card
      color="black.base"
      p="16px 16px 8px"
      fontSize="12px"
      minHeight="115px"
      w="224px"
    >
      <Flex pb="6px">
        <Box borderRadius="8px" w="34px" h="34px" overflow="hidden">
          <Image w="100%" src={profilepic4} />
        </Box>
        <Flex flexDir="column" justifyContent="space-between" pl="6px">
          <Text fontSize="12px" fontWeight="600">
            Marty Cooper
          </Text>
          <Text color="grey.light" fontSize="10px">
            Left a review on
            <Text color="blue.base" display="inline" pl="4px" fontSize="10px">
              Google
            </Text>
          </Text>
        </Flex>
      </Flex>
      <Icon type="StarSolid" boxSize="20px" color="gold" />
      <Icon type="StarSolid" boxSize="20px" color="gold" />
      <Icon type="StarSolid" boxSize="20px" color="gold" />
      <Icon type="StarSolid" boxSize="20px" color="gold" />
      <Icon type="StarSolid" boxSize="20px" color="gold" />
      <Box mt="10px" />
      <GreyLine w="100%" />
    </Card>
  );
};

const RightOneCard = () => {
  return (
    <Card
      color="black.base"
      p="16px"
      fontSize="12px"
      minHeight="60px"
      w="200px"
    >
      <Flex flexDir="row" alignItems="center" h="100%">
        <Box w="6px" h="6px" borderRadius="50%" bg="blue.base" mr="6px" />
        <Image src={avatarimg} w="24px" h="24px" />
        <Flex flexDir="column" ml="6px">
          <Text fontWeight="600" fontSize="12px" color="black.lighter">
            Rosie Sims
          </Text>
          <GreyLine w="120px" />
        </Flex>
      </Flex>
    </Card>
  );
};

const RightTwoCard = () => {
  return (
    <Card
      color="black.base"
      p="13px"
      fontSize="12px"
      minHeight="35px"
      w="145px"
    >
      <Flex flexDir="row" alignItems="center" h="100%">
        <Image src={phoneIcon} w="16px" h="16px" />
        <Image src={playIcon} w="10px" h="10px" />
        <Image src={volumeIcon} w="70px" h="24px" />
        <Text fontSize="8px" color="grey.lighter">
          0:32
        </Text>
      </Flex>
    </Card>
  );
};

const RightThreeCard = () => {
  return (
    <Card
      color="black.base"
      p="13px"
      fontSize="12px"
      minHeight="35px"
      w="170px"
      h="50px"
    >
      <Flex flexDir="row" alignItems="center" h="100%">
        <Image src={moneyIcon} w="20px" h="20px" />
        <Text fontSize="12px" fontWeight="600" color="black" ml="6px">
          Jane paid $40.00
        </Text>
      </Flex>
    </Card>
  );
};

const FooterQuote = () => {
  return (
    <Flex w="380px" mt="-200px">
      <Image src={footerPic} w="55px" h="55px" mr="25px" />
      <Text>"</Text>
      <Flex flexDir="column">
        <Text fontSize="14px" fontWeight="500" lineHeight="20px">
          Our response rate is under a minute right now. We’re able to drive a
          sale without having to speak on the phone."
        </Text>
        <Text
          fontSize="14px"
          fontWeight="400"
          lineHeight="20px"
          color="grey.lighter"
          mt="8px"
        >
          Zahadia Ortiz-Ceballos | Adam's Pest Control
        </Text>
      </Flex>
    </Flex>
  );
};

const GreyLine = ({ w }) => {
  return <Box w={w} h="14px" bg="#EEECEA" borderRadius="16px" />;
};
